const cartRoutes = [
  {
    // Cart route
    path: '/cart/:linkGuid',
    name: 'Cart',
    component: () => import('@/views/archistar/cart/CartClientPaymentLink.vue'),
    meta: {
      noAuthRequired: true
    }
  },
  {
    path: '/carts',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: '/carts/new/:cartGuid?',
        name: 'cart-new',
        component: () => import('@/views/archistar/cart/CartNew.vue'),
        meta: {
          breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Admin' }, { title: 'New Subscription', active: true }],
          pageTitle: 'New Subscription',
          rules: [
            {
              resource: 'create cart',
              rule: 'write'
            }
          ]
        }
      },
      {
        path: 'all',
        name: 'cart.all',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.all'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'All',
              active: true
            }
          ],
          pageTitle: 'All Carts',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'pending',
        name: 'cart.pending',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.pending'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Pending',
              active: true
            }
          ],
          pageTitle: 'Pending Carts',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'awaiting-approval',
        name: 'cart.awaiting-approval',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.awaitingApproval'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Awaiting Approval',
              active: true
            }
          ],
          pageTitle: 'Carts Awaiting Approval',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'rejected',
        name: 'cart.rejected',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.rejected'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Rejected',
              active: true
            }
          ],
          pageTitle: 'Rejected Carts',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'awaiting-payment',
        name: 'cart.awaitingPayment',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.awaitingPayment'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Awaiting Payment',
              active: true
            }
          ],
          pageTitle: 'Carts Awaiting Payment',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'completed',
        name: 'cart.completed',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.completed'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Completed',
              active: true
            }
          ],
          pageTitle: 'Completed Carts',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'failed-payment',
        name: 'cart.failedPayment',
        component: () => import('@/components/archistar/table/CartTable.vue'),
        props: {
          scope: 'cart.failedPayment'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Carts'
            },
            {
              title: 'Failed Payment',
              active: true
            }
          ],
          pageTitle: 'Failed Cart Payments',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default cartRoutes;
